import React from 'react'
import connect from "react-redux/es/connect/connect"
import moment from 'moment-timezone'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

import CheckCircleIcon from '@material-ui/icons/CheckCircle'

import {
  findOneBy,
} from '@relativity/js-util'

import styles from './style'
import {
  atRecordEditUpdateProperty,
  atRecordEditDone,
  atRecordDelete,
  atRecordEditSave,
  reviewAtRecordEditSave,
  createAtRecordForAbsentStudents,
  reviewAtRecordDelete
} from 'redux/admin/Actions'

import DialogTitle from 'common/components/dialog/DialogTitle'
import DialogContent from 'common/components/dialog/DialogContent'
import DialogActions from 'common/components/dialog/DialogActions'
import FancySelect from 'common/components/FancySelect'
import ToggleIconButton from 'common/components/ToggleIconButton'
import BuildingLocationName from "common/components/BuldingLocationName";
import {ID_ZERO, AT_TYPE_ID_UNKNOWN} from "redux/constants";
import {FullTextFieldD} from "common/components/FullTextField";

class AtRecordEditor extends React.Component {

  constructor(props) {
    super(props)
    this.toggleIsReportingAtRecord = this.toggleIsReportingAtRecord.bind(this)
    this.deleteAtRecord = this.deleteAtRecord.bind(this)
  }

  saveAtRecordActionMap = {
    "atRecordEditSave": this.props.atRecordEditSave,
    "reviewAtRecordEditSave": this.props.reviewAtRecordEditSave,
    "createAtRecordForAbsentStudents": this.props.createAtRecordForAbsentStudents
  }

  deleteAtRecordActionMap = {
    "atRecordDelete": this.props.atRecordDelete,
    "reviewAtRecordDelete": this.props.reviewAtRecordDelete
  }


  toggleIsReportingAtRecord() {
    if (this.props.atRecord.isReportingAtRecord && this.props.atRecord.vendorId !== '') {
      alert("Once synced, you cannot un-mark this record from being reporting. You must create a different reporting record, or explicitly delete this one")
    } else {
      this.props.atRecordEditUpdateProperty({
        propertyName: 'isReportingAtRecord',
        val: !this.props.atRecord.isReportingAtRecord
      })
    }
  }

  deleteAtRecord() {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Are you sure you want to delete this record? This action cannot be undone")) {
      this.deleteAtRecordActionMap[this.props.atRecordDeleteActionName]()
    }
  }

  render() {
    if(!this.props.atRecord) return null

    let atReason, atType, building, locations

    let { buildings, location } = this.props
    const {
      classes,
      //atRecordDelete, //leave this!
      atRecordEditDone,
      atRecordEditUpdateProperty,
      atRecord,
      atTypes,
      atReasons,
      byId,
      studentName,
      periodNumber,
      atRecordSaveActionName,
    } = this.props
    const atMoment = moment.unix(atRecord.uTime)

    atType = findOneBy(atTypes, 'id', atRecord.atTypeId? atRecord.atTypeId : 0)
    atReason = findOneBy(atReasons, 'id', atRecord.atReasonId? atRecord.atReasonId : 0)

    const atTypesForDisplay = atTypes.map(t => t.id === AT_TYPE_ID_UNKNOWN ? {...t, displayName: 'Unmapped'} : t)

    const locationZero = byId.location(ID_ZERO)
    const buildingZero = byId.building(ID_ZERO)
    const externalTypeDisplayName = (atRecord.atTypeExternalId > 0 && byId.atType(atRecord.atTypeExternalId))? ' (Current external:' + byId.atType(atRecord.atTypeExternalId).displayName + ')': ''

    building = byId.building(atRecord.buildingId? atRecord.buildingId : 0)
    if(building.id === 0) {
      buildings = [buildingZero].concat(buildings)
    }

    locations = byId.locationsByBuilding(building.id)
    if(!location || building.id !== location.buildingId) {
      location = locationZero
      locations = [locationZero].concat(locations? locations: [])
    }


    return (
      <Dialog
        onClose={atRecordEditDone}
        aria-labelledby="customized-dialog-title"
        open={true}
      >
        <DialogTitle id="customized-dialog-title" onClose={atRecordEditDone}>
          <ToggleIconButton
            onTitle='Use for attendance'
            offTitle='Will not be used for attendance'
            style={{marginLeft:-12, marginTop:-9,  position:'absolute'}}
            onClick={this.toggleIsReportingAtRecord}
            isOn={atRecord.isReportingAtRecord}
            onIcon={CheckCircleIcon}
          />
          {(!!atRecord.id)?
            (<span title={`Record ${atRecord.id}`} style={{marginLeft:36}}>
              <b>{atMoment.format('YYYY-MM-DD')}</b><span> / </span>
              <b>{periodNumber}</b><span> / </span>
              <b>{location.id === ID_ZERO? '' : location.displayName}</b><span> </span>
              <span style={{whiteSpace:'nowrap'}}>{building.id === ID_ZERO? 'No location specified' : building.displayName }</span>
            </span>)
            :
            <span style={{marginLeft:36}}>Create a new attendance record - <b style={{whiteSpace:'nowrap'}}>{studentName}</b></span>
          }
        </DialogTitle>
        <DialogContent className={classes.dialogContentRoot}>
            <Grid container>
              {!!atRecord.id? null : <Grid item xs={12}>
                <FullTextFieldD label={'Date'} value={atMoment.format('MMMM D')} />
              </Grid> }
              {!!atRecord.id? null : <Grid item xs={12}>
                <FullTextFieldD label={'Period'} value={periodNumber} />
              </Grid> }
              <Grid item xs={12}>
                <FancySelect label={`Type${externalTypeDisplayName}`} propertyName={'atTypeId'} nameAtr={'displayName'} currentItem={atType} items={atTypesForDisplay} dispatchUpdate={atRecordEditUpdateProperty}/>
              </Grid>
              <Grid item xs={12}>
                <FancySelect label={'Reason'} propertyName={'atReasonId'} nameAtr={'displayName'} currentItem={atReason} items={atReasons} dispatchUpdate={atRecordEditUpdateProperty}/>
              </Grid>
              {!!atRecord.id? <Grid item xs={12}>
                <TextField
                  disabled
                  id="outlined-disabled"
                  label="When"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  value={atMoment.format('YYYY-MM-DD HH:mm:ss')}
                />
              </Grid> : null }
              {!!atRecord.id? null : <Grid item xs={12}>
                <FancySelect
                  label={'Building'}
                  propertyName={'buildingId'}
                  currentItem={building}
                  items={buildings}
                  nameAtr={'displayName'}
                  dispatchUpdate={atRecordEditUpdateProperty}/>
                <FancySelect
                  label={'Location'}
                  propertyName={'locationId'}
                  currentItem={location}
                  items={locations}
                  nameAtr={(item)=>{return <BuildingLocationName byId={byId} locationId={item.id} />}}
                  dispatchUpdate={atRecordEditUpdateProperty}/>
              </Grid> }
              <Grid item xs={12}>
              <TextField
                id="outlined-multiline-notes"
                label="Notes"
                multiline
                fullWidth
                rows="4"
                className={classes.textField}
                margin="normal"
                variant="outlined"
                value={atRecord.notes}
                onChange={(e)=>{
                  atRecordEditUpdateProperty({propertyName:'notes', val:e.target.value})
                }}
              />
              </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
          <div style={{flexGrow:10}}>
            <Button onClick={this.deleteAtRecord} color="secondary" style={{float:'left'}}>
              Delete
            </Button>
          </div>
          <Button onClick={atRecordEditDone} color="secondary">
            Cancel
          </Button>
          <Button onClick={this.saveAtRecordActionMap[atRecordSaveActionName]} color="primary">
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const mapStateToProps = state => (state.admin.dialogs.atRecordEditor)?
  Object.assign({byId:state.admin.byId, buildings: state.admin.permittedBuildings}, state.admin.dialogs.atRecordEditor)
  :
  {}

const mapDispatchToProps = {
  atRecordDelete,
  atRecordEditDone,
  atRecordEditSave,
  atRecordEditUpdateProperty,
  reviewAtRecordEditSave,
  createAtRecordForAbsentStudents,
  reviewAtRecordDelete
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(AtRecordEditor))